import { render, staticRenderFns } from "./Token.vue?vue&type=template&id=7c4148db&scoped=true"
import script from "./Token.vue?vue&type=script&lang=js"
export * from "./Token.vue?vue&type=script&lang=js"
import style0 from "./Token.vue?vue&type=style&index=0&id=7c4148db&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4148db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c4148db')) {
      api.createRecord('7c4148db', component.options)
    } else {
      api.reload('7c4148db', component.options)
    }
    module.hot.accept("./Token.vue?vue&type=template&id=7c4148db&scoped=true", function () {
      api.rerender('7c4148db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/text/Token.vue"
export default component.exports